var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('ControlNavbar'),_c('div',{staticClass:"header"},[_vm._v(" PROFILE ")]),_c('br'),_vm._v(" VERIFICATION PAGE ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }